import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function G3() {
    const { useLang } = useGlobal();
    const { t } = useLang('vanliferoadtrips');

    return (
        <div id="vanlife-roadtrips-G2" className={`vanlife-roadtrips-G3 ${css['vanlife-roadtrips-G3']}`}>
            <EcoImg
                pc="https://websiteoss.ecoflow.com/figma-uploads/1786703465786-1cmt2s-compressed-005.webp"
                h5="https://websiteoss.ecoflow.com/figma-uploads/1786703487416-j49trt-compressed-005.webp"
                alt={t('secG2_title')}
                aria-label={t('secG2_title')}
            />
            <div className="info">
                <p className="title">{t('secG2_title')}</p>
                <p className="desc">{t('secG2_desc')}</p>
            </div>
        </div>
    );
}
